module.exports = __webpack_public_path__ + "img/pr-18.e445dda2.png";